<template>
    <div class="bg-neutral-100 py-6 px-4 sm:px-6">
        <div class="md:max-w-sm mx-auto">
            <!-- Preview del audio -->

            <div v-if="!audioURL && false" class="space-y-6">
                <div class="">
                    <a :href="`https://tally.so/r/m6pOAO?id_cuento=${idCuento}`" target="_blank"
                        rel="noopener noreferrer"
                        class="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
                        </svg>

                        <span class="text-lg">Subir tu audio</span>
                    </a>
                </div>
            </div>


            <div v-else-if="audioURL" class="space-y-6">
                <div class="bg-white rounded p-4 shadow-sm">
                    <div class="flex items-start justify-between">
                        <audio :src="audioURL" controls class="w-[calc(100%-3rem)]"></audio>
                        <button @click.prevent="deleteRecording"
                            class="ml-2 p-2 text-neutral-400 hover:text-red-500 transition-colors">
                            <!-- X Mark Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-5 h-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="mt-4 flex items-center justify-between gap-4">
                        <button @click.prevent="downloadRecording"
                            class="flex items-center justify-center gap-2 py-2 px-4 text-sm text-neutral-600 hover:text-neutral-900"
                            :disabled="isUploading">
                            <!-- Arrow Down Tray Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                            </svg>
                            Descargar
                        </button>

                        <button @click.prevent="saveRecording"
                            class="flex-1 bg-neutral-900 text-white py-2 px-6 rounded-lg hover:bg-neutral-800 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            :disabled="isUploading">
                            <template v-if="!isUploading">
                                <!-- Check Icon -->
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                                Guardar
                            </template>
                            <template v-else>
                                <!-- Loading spinner -->
                                <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                                Subiendo...
                            </template>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Opciones de grabación/upload -->
            <div v-else class="space-y-6">
                <!-- Opción 1: Grabación -->
                <div class="bg-white rounded p-4 shadow-sm">
                    <div v-if="!recording" class="flex justify-center">
                        <button @click.prevent="startRecording"
                            class="bg-neutral-900 text-white px-6 py-3 rounded-lg hover:bg-neutral-800 transition-colors flex items-center gap-2">
                            <!-- Microphone Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-5 h-5">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
                            </svg>
                            Grabar audio
                        </button>
                    </div>

                    <div v-else class="space-y-4">
                        <div class="flex items-center justify-center gap-4">
                            <!-- Recording indicator -->
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-4 h-4 text-red-500 animate-pulse">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span class="font-mono text-neutral-600">{{ formattedTime }}</span>
                        </div>

                        <div class="flex justify-center gap-3">
                            <button @click.prevent="togglePause"
                                class="bg-neutral-100 text-neutral-600 px-4 py-2 rounded-lg hover:bg-neutral-200 transition-colors flex items-center gap-2">
                                <template v-if="isPaused">
                                    <!-- Play Icon -->
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347c-.75.412-1.667-.13-1.667-.986V5.653z" />
                                    </svg>
                                    Continuar
                                </template>
                                <template v-else>
                                    <!-- Pause Icon -->
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
                                    </svg>
                                    Pausar
                                </template>
                            </button>

                            <button @click.prevent="stopRecording"
                                class="bg-neutral-900 text-white px-4 py-2 rounded-lg hover:bg-neutral-800 transition-colors flex items-center gap-2">
                                <!-- Stop Icon -->
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z" />
                                </svg>
                                Detener
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Divisor -->
                <!-- <div class="flex items-center justify-center gap-4">
                    <div class="h-px bg-neutral-200 flex-1"></div>
                    <span class="text-neutral-400 text-sm">o</span>
                    <div class="h-px bg-neutral-200 flex-1"></div>
                </div> -->

                <!-- Opción 2: Subir archivo -->
                <!-- <div class="bg-white rounded p-4 shadow-sm">
                    <label class="block">
                        <div
                            class="flex flex-col items-center justify-center gap-2 p-4 border-2 border-dashed border-neutral-200 rounded-lg hover:border-neutral-300 transition-colors cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6 h-6 text-neutral-400">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z" />
                            </svg>
                            <span class="text-sm text-neutral-600">Subir archivo o grabar audio</span>
                            <input type="file" @change="handleFileUpload"
                                accept="audio/*,audio/3gpp,audio/3gpp2,audio/aiff,audio/x-aiff,audio/amr,audio/mp3,audio/mpeg3,audio/x-mp3,audio/x-mpeg3,audio/mp4,audio/mpeg,audio/x-mpeg,audio/wav,audio/x-wav,audio/x-m4a,audio/x-m4b,audio/x-m4p,video/3gpp,video/3gpp2,video/mp4,video/quicktime,video/x-m4v,.3gp,.3gpp,.3g2,.3gp2,.aiff,.aif,.aifc,.cdda,.amr,.mp3,.swa,.mp4,.mpeg,.mpg,.wav,.bwf,.m4a,.m4b,.m4p,.mov,.qt,.mqv,.m4v"
                                class="hidden" :disabled="isUploading" />
                        </div>
                    </label>
                </div> -->

                <!-- Divisor -->


                <!-- Opción 3: Formulario Tally -->
                <div class="mt-6 text-center">
                    <a :href="`https://tally.so/r/m6pOAO?id_cuento=${idCuento}`" target="_blank"
                        rel="noopener noreferrer"
                        class="text-red-500/70 hover:text-red-600 text-sm inline-flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-4 h-4">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                        </svg>
                        ¿Problemas con el audio? Click aquí
                    </a>
                </div>
            </div>

            <!-- Mensajes de error -->
            <div v-if="error" class="mt-4 p-4 bg-red-50 text-red-600 rounded-lg flex items-center gap-2 text-sm">
                <!-- Alert Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-4 h-4 flex-shrink-0">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
                {{ error }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import strapiService from '@/services/strapi'
import { notify } from "notiwind";

// Estado
const recording = ref(false)
const isPaused = ref(false)
const error = ref(null)
const mediaRecorder = ref(null)
const recordedChunks = ref([])
const startTime = ref(0)
const elapsedTime = ref(0)
const timer = ref(null)
const showFallbackForm = ref(false)
const isUploading = ref(false)
const stream = ref(null)

const props = defineProps({
    context: {
        type: Object,
        required: true,
    },
    id_cuento: {
        type: String,
        required: true
    }
});
const urlAudio = ref(props.context._value || '');
const idCuento = computed(() => props.context.attrs.props.id_cuento);


console.log(urlAudio.value);
const audioURL = ref(urlAudio.value || null);

// Configuración de Strapi
const STRAPI_URL = 'https://staging-strapi.orsai.org'
const STRAPI_UPLOAD_ENDPOINT = `${STRAPI_URL}/api/upload`
const cuentoActual = ref(null);

// Funcion reload dentro de las props
const reload = computed(() => props.context.attrs.props.reload);

onMounted(async () => {


    // Obtener el cuento con strapi
    const res = await strapiService.get(`/api/cuentos?filters[id]=${idCuento.value}`);
    const cuento = res.data[0];
    console.log("cuento", cuento.audio_v2);
    audioURL.value = cuento.audio_v2;
    cuentoActual.value = cuento;
})

// Tiempo formateado
const formattedTime = computed(() => {
    const minutes = Math.floor(elapsedTime.value / 60)
    const seconds = elapsedTime.value % 60
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
})

// Limpiar recursos al desmontar
onBeforeUnmount(() => {
    stopRecording()
    if (stream.value) {
        stream.value.getTracks().forEach(track => track.stop())
    }
})

// Función para obtener el MIME type soportado
const getSupportedMimeType = () => {
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/mp4',
        'audio/aac',
        'audio/wav'
    ]

    for (const type of types) {
        if (MediaRecorder.isTypeSupported(type)) {
            return type
        }
    }

    return null
}

// Iniciar grabación
const startRecording = async () => {
    try {
        // Resetear estado
        recordedChunks.value = []
        error.value = null

        // Verificar soporte de MediaRecorder
        if (!navigator.mediaDevices || !window.MediaRecorder) {
            throw new Error('Tu navegador no soporta la grabación de audio. Por favor, intenta con otro navegador o usa la opción de subir archivo.')
        }

        // Solicitar permisos y obtener stream con configuración optimizada para iOS
        stream.value = await navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: { ideal: true },
                noiseSuppression: { ideal: true },
                autoGainControl: { ideal: true },
                sampleRate: { ideal: 44100 },
                channelCount: { ideal: 1 }
            }
        })

        // Obtener MIME type soportado
        const mimeType = getSupportedMimeType()
        if (!mimeType) {
            throw new Error('No se encontró un formato de audio compatible. Por favor, intenta con otro navegador o usa la opción de subir archivo.')
        }

        // Crear MediaRecorder con opciones optimizadas
        const options = {
            mimeType,
            audioBitsPerSecond: 128000
        }

        try {
            mediaRecorder.value = new MediaRecorder(stream.value, options)
        } catch (e) {
            console.error('Error al crear MediaRecorder:', e)
            // Intentar crear MediaRecorder sin opciones como fallback
            mediaRecorder.value = new MediaRecorder(stream.value)
        }

        // Configurar handlers
        mediaRecorder.value.ondataavailable = (event) => {
            if (event.data && event.data.size > 0) {
                recordedChunks.value.push(event.data)
            }
        }

        mediaRecorder.value.onstart = () => {
            recording.value = true
            isPaused.value = false
            startTime.value = Date.now()
            timer.value = setInterval(() => {
                elapsedTime.value = Math.floor((Date.now() - startTime.value) / 1000)
            }, 1000)
        }

        mediaRecorder.value.onstop = async () => {
            clearInterval(timer.value)
            recording.value = false

            try {
                // Crear Blob con el tipo correcto
                const blob = new Blob(recordedChunks.value, { type: mediaRecorder.value.mimeType || 'audio/webm' })
                audioURL.value = URL.createObjectURL(blob)
            } catch (e) {
                console.error('Error al crear blob:', e)
                error.value = 'Error al procesar la grabación. Por favor, intenta nuevamente.'
            }
        }

        mediaRecorder.value.onerror = (event) => {
            console.error('Error en MediaRecorder:', event.error)
            error.value = 'Error en la grabación. Por favor, intenta nuevamente o usa la opción de subir archivo.'
            stopRecording()
        }

        // Iniciar grabación con chunks más pequeños para mejor manejo en iOS
        mediaRecorder.value.start(250) // Capturar chunks cada 250ms

    } catch (err) {
        console.error('Error al iniciar la grabación:', err)
        error.value = err.message || 'Error al acceder al micrófono. Por favor, verifica los permisos o usa la opción de subir archivo.'
        showFallbackForm.value = true
    }
}

// Pausar/Reanudar grabación
const togglePause = () => {
    if (!mediaRecorder.value) return

    if (isPaused.value) {
        mediaRecorder.value.resume()
        isPaused.value = false
        startTime.value = Date.now() - (elapsedTime.value * 1000)
        timer.value = setInterval(() => {
            elapsedTime.value = Math.floor((Date.now() - startTime.value) / 1000)
        }, 1000)
    } else {
        mediaRecorder.value.pause()
        isPaused.value = true
        clearInterval(timer.value)
    }
}

// Detener grabación
const stopRecording = () => {
    if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') {
        mediaRecorder.value.stop()
        clearInterval(timer.value)
    }

    if (stream.value) {
        stream.value.getTracks().forEach(track => track.stop())
    }
}

// Eliminar grabación
const deleteRecording = () => {
    if (audioURL.value) {
        try {
            URL.revokeObjectURL(audioURL.value)
        } catch (e) {
            console.error('Error al revocar URL:', e)
        }
    }
    audioURL.value = null
    recordedChunks.value = []
    elapsedTime.value = 0
}

// Descargar grabación
const downloadRecording = () => {
    if (!recordedChunks.value.length) return

    const mimeType = mediaRecorder.value?.mimeType || 'audio/webm'
    const blob = new Blob(recordedChunks.value, { type: mimeType })
    const extension = getExtensionFromMimeType(mimeType)
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `grabacion-${Date.now()}.${extension}`
    a.click()
    URL.revokeObjectURL(url)
}

// Subir archivo a Strapi
const uploadToStrapi = async (file) => {
    try {
        const formData = new FormData()
        formData.append('files', file)

        const response = await fetch(STRAPI_UPLOAD_ENDPOINT, {
            method: 'POST',
            body: formData
        })


        if (!response.ok) {
            throw new Error('Error al subir el archivo')
        }

        const data = await response.json()

        let url = data[0].url;

        // Verificar si tiene la url completa
        // if (!url.includes('staging-strapi.orsai.org') && !url.includes('http')) {
        //     url = `https://staging-strapi.orsai.org${url}`;
        // }

        // Guardar actualizando el cuento
        try {
            await strapiService.put(`/api/cuentos/${cuentoActual.value.documentId}`, {
                data: {
                    audio_v2: url
                }
            })
        } catch (err) {
            await strapiService.put(`/api/cuentos/${cuentoActual.value.documentId}`, {
                data: {
                    audio_v_2: url
                }
            })
        }
        return url;

        notify({
            group: "foo",
            title: "¡Listo!",
            type: "success",
            text: "Tu audio se guardó correctamente."
        })



    } catch (err) {
        console.error('Error en la subida:', err)
        throw err
    }
}

// Manejar subida de archivo
const handleFileUpload = async (event) => {
    const file = event.target.files[0]
    if (!file) {
        error.value = 'Por favor, selecciona o graba un archivo'
        return
    }

    try {
        isUploading.value = true
        // Crear preview URL para archivos de audio y video
        if (file.type.startsWith('audio/') || file.type.startsWith('video/')) {
            audioURL.value = URL.createObjectURL(file)
        }

        // Subir a Strapi
        const publicUrl = await uploadToStrapi(file)
        const baseUrl = 'https://staging-strapi.orsai.org'
        props.context.node.input(`${baseUrl}${publicUrl}`);

    } catch (err) {
        error.value = 'Error al subir el archivo. Por favor, intenta nuevamente.'
        audioURL.value = null
    } finally {
        isUploading.value = false
    }
}

const getExtensionFromMimeType = (mimeType) => {
    const mimeToExt = {
        'audio/3gpp': '3gp',
        'audio/3gpp2': '3g2',
        'audio/aiff': 'aiff',
        'audio/x-aiff': 'aiff',
        'audio/amr': 'amr',
        'audio/mp3': 'mp3',
        'audio/mpeg3': 'mp3',
        'audio/x-mp3': 'mp3',
        'audio/x-mpeg3': 'mp3',
        'audio/mp4': 'mp4',
        'audio/mpeg': 'mp3',
        'audio/x-mpeg': 'mp3',
        'audio/wav': 'wav',
        'audio/x-wav': 'wav',
        'audio/x-m4a': 'm4a',
        'audio/x-m4b': 'm4b',
        'audio/x-m4p': 'm4p',
        'video/3gpp': '3gp',
        'video/3gpp2': '3g2',
        'video/mp4': 'mp4',
        'video/quicktime': 'mov',
        'video/x-m4v': 'm4v',
        'audio/webm': 'webm'
    }
    return mimeToExt[mimeType] || 'mp3' // fallback a mp3 si no se encuentra el tipo
}



// Modificar saveRecording para manejar diferentes formatos
const saveRecording = async () => {
    if (!recordedChunks.value.length) return

    try {
        isUploading.value = true
        const mimeType = mediaRecorder.value?.mimeType || 'audio/webm'
        const blob = new Blob(recordedChunks.value, { type: mimeType })
        const extension = getExtensionFromMimeType(mimeType)
        const file = new File([blob], `grabacion-${Date.now()}.${extension}`, { type: mimeType })

        const publicUrl = await uploadToStrapi(file)
        const baseUrl = 'https://staging-strapi.orsai.org'
        console.log('Grabación subida:', `${baseUrl}${publicUrl}`)





        props.context.node.input(`${baseUrl}${publicUrl}`)


        notify({
            group: "foo",
            title: "¡Listo!",
            type: "success",
            text: "Tu audio se guardó correctamente."
        })
        reload.value();

    } catch (err) {
        console.error('Error al guardar:', err)
        error.value = 'Error al guardar la grabación. Por favor, intenta nuevamente o usa la opción de subir archivo.'
    } finally {
        isUploading.value = false
    }
}

</script>